import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

export enum AlertType {
    'error' = 1,
    'warning',
    'success',
    'info',
} 

export interface Alert {
    message: string,
    type: AlertType
}

export enum MySpaceRenderableComponent {
    'Home' = 0,
    'DocumentDeposit',
    'SentDocuments',
    'BCTutorials'
}

export enum FolderRenderableComponent {
    'FolderHome' = 1,
    'ChemiseDetails',
    'SentDocuments',
    'Events'
}

export interface TableCol {
    name: string,
    tabIndex?: number,
    show?: boolean,
    formatBeforeRender?: Function,
    sort?: SortType | Function,
    className?: string,
    usedForResearch?: boolean,
    hint?: string
}

export interface TableRow {
    id: number | string;
    [key: string]: any;
}

export interface TableInteractionBtn {
    name: string;
    icon: IconDefinition;
    action: Function;
    withoutSelection?: boolean;
}

export enum SortType {
    'Alphanumeric' = 1,
    'Date',
    'Number'
}

export enum SortOrder {
    asc = 'asc',
    desc = 'desc'
}

export interface FileSize {
    size: number;
    unit: FileSizeUnit;
}

export enum FileSizeUnit {
    'octet' = 'octet',
    'Ko' = 'Ko',
    'Mo' = 'Mo',
    'Go' = 'Go'
}
